module.exports = __webpack_public_path__ + "static/fipcbrownleopard1-1792caf8196ae39774040b8bc210e3a5.jpeg";